"use strict";
// References:
// https://github.com/wix-private/scheduler/blob/master/statics/owner/bookings-calendar-statics/src/query-builder.ts
// https://bo.wix.com/wix-docs/rnd/platformization-guidelines/api-query-language#platformization-guidelines_api-query-language_the-filter-section
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCondition = exports.hasAll = exports.exists = exports.equal = exports.gte = exports.and = exports.hasSome = exports.or = void 0;
var hasSome = function (values) {
    if (values === void 0) { values = []; }
    return ({
        build: function () {
            return { $hasSome: values };
        },
    });
};
exports.hasSome = hasSome;
var hasAll = function (values) {
    if (values === void 0) { values = []; }
    return ({
        build: function () {
            return { $hasAll: values };
        },
    });
};
exports.hasAll = hasAll;
var gte = function (values) {
    if (values === void 0) { values = []; }
    return ({
        build: function () {
            return { $gte: values };
        },
    });
};
exports.gte = gte;
var equal = function (value) { return ({
    build: function () {
        return { $eq: value };
    },
}); };
exports.equal = equal;
var exists = function (value) { return ({
    build: function () {
        return { $exists: value };
    },
}); };
exports.exists = exists;
function buildCondition(cond) {
    var _a;
    if (typeof cond.build === 'function') {
        return cond.build();
    }
    var _b = Object.entries(cond)[0], key = _b[0], value = _b[1];
    var condValue = typeof value.build === 'function';
    return _a = {}, _a[key] = condValue ? value.build() : value, _a;
}
exports.buildCondition = buildCondition;
function or(firstCond) {
    var conditions = [buildCondition(firstCond)];
    return {
        or: function (cond) {
            conditions.push(buildCondition(cond));
            return this;
        },
        build: function () {
            return {
                $or: conditions,
            };
        },
    };
}
exports.or = or;
function and(firstCond) {
    var conditions = [buildCondition(firstCond)];
    return {
        and: function (cond) {
            conditions.push(buildCondition(cond));
            return this;
        },
        build: function () {
            return {
                $and: conditions,
            };
        },
    };
}
exports.and = and;
//# sourceMappingURL=query-builder.js.map